import { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import './Navbar.css';

export default function Navbar() {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [avatarSrc, setAvatarSrc] = useState('https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png');

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const loadAvatar = () => {
            const storedAvatar = localStorage.getItem('customAvatar');
            if (storedAvatar) {
                setAvatarSrc(storedAvatar);
            }
        };

        loadAvatar();

        window.addEventListener('avatar-updated', loadAvatar);
        return () => window.removeEventListener('avatar-updated', loadAvatar);
    }, []);

    const handleLogout = async () => {
        try {
            await signOut(auth);
            navigate('/login');
            setIsMenuOpen(false);
        } catch (error) {
            console.error('Failed to log out', error);
        }
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const handleAvatarClick = () => {
        navigate('/profile');
    };

    return (
        <header className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
            <div className="navbar__container">
                <NavLink to="/" className="navbar__logo" onClick={closeMenu}>
                    Notflix
                </NavLink>

                <button className="navbar__toggle" onClick={toggleMenu} aria-label="Toggle navigation">
                    <span className={`navbar__toggle-bar ${isMenuOpen ? 'open' : ''}`}></span>
                    <span className={`navbar__toggle-bar ${isMenuOpen ? 'open' : ''}`}></span>
                    <span className={`navbar__toggle-bar ${isMenuOpen ? 'open' : ''}`}></span>
                </button>

                <div className={`navbar__links ${isMenuOpen ? 'open' : ''}`}>
                    <NavLink
                        to="/"
                        className={({ isActive }) => isActive ? "navbar__link active" : "navbar__link"}
                        onClick={closeMenu}
                    >
                        Home
                    </NavLink>
                    <NavLink
                        to="/search"
                        className={({ isActive }) => isActive ? "navbar__link active" : "navbar__link"}
                        onClick={closeMenu}
                    >
                        Search
                    </NavLink>
                    <NavLink
                        to="/mylist"
                        className={({ isActive }) => isActive ? "navbar__link active" : "navbar__link"}
                        onClick={closeMenu}
                    >
                        My List
                    </NavLink>

                    <div className="navbar__profile">
                        <img
                            src={avatarSrc}
                            alt="User Profile"
                            className="navbar__avatar"
                            onClick={handleAvatarClick}
                            title="Vai al tuo Profilo"
                        />
                        <button onClick={handleLogout} className="navbar__logout-btn">Logout</button>
                    </div>
                </div>
            </div>
        </header>
    )
}
